module.exports = __webpack_public_path__ + "static/media/contact20.7995fa85.png";